import React, {FunctionComponent} from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight} from '@fortawesome/free-solid-svg-icons'
import {IProps} from './IProps'
import style from './TablePager.scss'

export const TablePager: FunctionComponent<IProps> = (
    {
        pages,
        currentPage,
        onPageClick
    }) => {
    const getPages = (current: number, maximumPage: number) => {
        let startPage = current - 4
        let endPage = current + 5

        if (startPage <= 0) {
            endPage -= startPage - 1
            startPage = 1
        }

        if (endPage > maximumPage) {
            startPage -= (endPage - maximumPage)
            endPage = maximumPage

            if (startPage <= 0) {
                startPage = 1
            }
        }

        const creatPaginationArray: number[] = []
        for (let i = startPage; i <= endPage; i++) {
            creatPaginationArray.push(i)
        }
        return creatPaginationArray
    }

    if (!pages || pages === 1) {
        return null
    }

    const pageButtons = []

    pageButtons.push(
        <button onClick={() => onPageClick(1)} disabled={currentPage === 1} key="pagerFirst">
            <FontAwesomeIcon icon={faAngleDoubleLeft}/>
        </button>
    )

    pageButtons.push(
        <button onClick={() => Math.max(1, currentPage - 1)} disabled={currentPage === 1} key="pagerPrev">
            <FontAwesomeIcon icon={faAngleLeft}/>
        </button>
    )

    const paginationArray: number[] = getPages(currentPage, pages)
    for (let pageNumber = 1; pageNumber <= pages; pageNumber++) {
        paginationArray.includes(pageNumber)
            ? pageButtons.push(
            <button onClick={() => onPageClick(pageNumber)}
                    className={pageNumber === currentPage ? style.active : ''}
                    key={`pager + ${pageNumber}`}>
                {pageNumber}
            </button>)
            : null
    }

    pageButtons.push(
        <button onClick={() => onPageClick(Math.min(pages, currentPage + 1))} disabled={currentPage === pages}
                key="pagerNext">
            <FontAwesomeIcon icon={faAngleRight}/>
        </button>
    )

    pageButtons.push(
        <button onClick={() => onPageClick(pages)} disabled={currentPage === pages} key="pagerLast">
            <FontAwesomeIcon icon={faAngleDoubleRight}/>
        </button>
    )

    return <div className={style.pager}>
        {pageButtons}
    </div>
}
